import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Check, Pencil, RotateCcw, X, ExternalLink } from "lucide-react";
import api from "../lib/api";

export default function FixMatchModal({ item, shop, label, activeId, onClose, onSaved }) {
  const [value, setValue] = useState(item?.product || "");
  useEffect(() => { setValue(item?.product || ""); }, [item]);
  if (!item) return null;

  const save = async (product) => {
    try {
      await api.put("/shopping/product-fix", { household_id: activeId, shop, name: item.name, product });
      toast.success(product ? `Got it — I'll always pick "${product}" for ${item.name} at ${label}` : `Back to my pick for ${item.name}`);
      onSaved(); onClose();
    } catch { toast.error("Couldn't save that"); }
  };

  return (
    <div className="fixed inset-0 z-[70] bg-sorted-ink/40 backdrop-blur-sm flex items-end justify-center" onClick={onClose} data-testid="fix-match-modal">
      <div className="w-full max-w-md bg-[#FFF6F1] rounded-t-[2rem] p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center gap-2">
          <span className="w-9 h-9 rounded-2xl bg-white flex items-center justify-center text-sorted-rose"><Pencil size={16} strokeWidth={2.5} /></span>
          <div className="flex-1">
            <p className="font-heading font-semibold text-sorted-ink leading-tight">Fix the match for {item.name}</p>
            <p className="text-[11px] text-sorted-slate font-semibold">Type it exactly as {label} names it. Millie remembers this for your household.</p>
          </div>
          <button onClick={onClose} aria-label="Close" data-testid="fix-match-close" className="w-9 h-9 rounded-full bg-white flex items-center justify-center text-sorted-slate"><X size={16} strokeWidth={3} /></button>
        </div>
        <input autoFocus value={value} onChange={(e) => setValue(e.target.value)} onKeyDown={(e) => e.key === "Enter" && value.trim() && save(value.trim())} data-testid="fix-match-input"
          className="mt-4 w-full bg-white rounded-2xl px-4 py-3 font-semibold text-sorted-ink outline-none focus:ring-2 focus:ring-sorted-peach border-2 border-[#FDECEF]" placeholder={`e.g. ${label} Full Cream Milk 2L`} />
        <a href={item.search_url} target="_blank" rel="noreferrer" data-testid="fix-match-search" className="mt-2 inline-flex items-center gap-1 text-[11px] font-bold text-sorted-rose">Look it up on {label} <ExternalLink size={11} /></a>
        <div className="mt-4 flex gap-2">
          {item.fixed && <button onClick={() => save("")} data-testid="fix-match-reset" className="flex-1 bg-white border-2 border-[#FDECEF] text-sorted-ink font-bold py-3 rounded-full flex items-center justify-center gap-1 text-sm"><RotateCcw size={14} strokeWidth={2.5} /> Use Millie's pick</button>}
          <button onClick={() => value.trim() && save(value.trim())} disabled={!value.trim()} data-testid="fix-match-save" className="flex-1 bg-sorted-ink text-white font-bold py-3 rounded-full flex items-center justify-center gap-1 text-sm disabled:opacity-50"><Check size={15} strokeWidth={3} /> Save &amp; remember</button>
        </div>
      </div>
    </div>
  );
}
